import React, { useMemo } from 'react';
import { ImageInfo } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Image';
import { getImageInfoUrl } from 'utils/ImageUtils';
import classNames from 'classnames';

export type IImageInfoControlProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  image?: ImageInfo | null;
  //TODO: we need to consider using Icon component sizes as alternative to width and height
  width?: number;
  height?: number;
  color?: string;
} & (
    | {
        /**
         * Applied if @param image is null or image cannot be retrieved
         */
        defaultImageUrl?: string;
        noImage?: never;
      }
    | {
        defaultImageUrl?: never;
        noImage?: JSX.Element;
      }
  );

/**
 * Displays image info
 *
 * Copyright (c) 2023 Decisions All Rights Reserved
 */
export function ImageInfoControl({
  image,
  defaultImageUrl,
  noImage,
  alt,
  width,
  height,
  color,
  ...otherProps
}: IImageInfoControlProps) {
  const imageUrl = useMemo(() => {
    return image ? getImageInfoUrl(image, width, height, color) ?? undefined : undefined;
  }, [color, height, image, width]);

  if (!imageUrl) {
    return noImage ?? null;
  }

  return (
    <img
      className={classNames('dp-image-info-control', {
        'dp-image-info-control--default': imageUrl == null && defaultImageUrl != null,
      })}
      src={imageUrl}
      alt={alt}
      {...otherProps}
    />
  );
}
